exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switch-toggle {\n    float: left;\n    background: #242729;\n }\n .switch-toggle input {\n   position: absolute;\n   opacity: 0;\n  \n }\n .switch-toggle input + label {\n   padding: 7px;\n   float:left;\n  \n   cursor: pointer;\n }\n .switch-toggle input:checked + label {\n   background: green;\n }", ""]);

